/* eslint 'no-redeclare': 'off', eqeqeq: 'off' */ 
import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from 'classnames';
import AddMetersSearch from '../CreateTenant/Modal_Forms_Create/AddMetersSearch';
import {Button,Table,Modal } from 'reactstrap';
import 'react-table/react-table.css';
import { SaveMeterDetails,UpdateMeterDetails,DeleteMeters,GetMeterListforTenant } from '../../../../../../action/tenantMeterAction';
import DeleteConfirmation from '../../_ModalsForms/DeleteConfirmation';
import DMResources from '../../../../../../Resources/DMResources.en-US';
import Currencies from '../../../../../../Resources/Currencies';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import Conversions from '../../../../../../Resources/Conversions';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes'; 
import 'semantic-ui-css/semantic.min.css';

let MeterList = [];
let IsEdit = false;
let TenantID = 0;
let MeterDetail = [];
class ViewUsageMeters extends Component {

  componentWillMount() {
     TenantID = this.props.userID || localStorage.getItem('userID');
     this.props.GetMeterListforTenant(TenantID);
  }

  constructor(props){
    super(props);
    this.state = {
      usage_meters : [],
      Deletemodal: false,
      error_msg: false,
      DatalogModalSearch: false,
      sort:{
        column: 'customName',
        direction:[
            {name:'customName', direction:'asc', onclick:true},
        ]
      },
      IsDefaultSort: true,
      IsChangesSaved: false,
    };
    this.Deletetoggle = this.Deletetoggle.bind(this);
    this.DeleteMeter = this.DeleteMeter.bind(this);
    this.toggleMeter = this.toggleMeter.bind(this);
}

async componentWillReceiveProps(nextProps) {
  if(this.props != nextProps) {
  //   this.setState({  
  //     usage_meters : nextProps.UsageMeters_response
  //     });
    this.setState({
      IsChangesSaved: true,
    });
  }
}

DeleteMeter(){
  this.setState({ error_msg: false });
  var checkboxes = document.getElementsByClassName('UsageRows');
  var IsAnyChecked = false;
  for (var i = 0; i < checkboxes.length; i++) {
    if (checkboxes[i].checked === true) {
      IsAnyChecked = true;
    }
  }
  if (IsAnyChecked) {
    this.Deletetoggle();
  }else{
    this.setState({ error_msg: true });
  }
}

Deletetoggle() {
    this.setState({  Deletemodal: !this.state.Deletemodal });
}


ViewMeterDetailslink(MeterId) {
  this.setState({
      MeterID: MeterId,
      DatalogModalSearch: !this.state.DatalogModalSearch 
  });
  IsEdit = true;
  MeterDetail = MeterList.filter(function(item){
    return item.consumptionId == MeterId;
  });
}

Delete = (someArg) => {
  if(someArg=="yes"){
    var Data =[];
    var checkboxes = document.getElementsByClassName('UsageRows');
    for (var i = 0; i < checkboxes.length; i++) {
      if  (checkboxes[i].checked === true) {
          var Meter_id_to_be_deleted = {
              "MeterId" : checkboxes[i].id 
          }
     Data.push(Meter_id_to_be_deleted);
      } 
      
     }
     if(Data.length>0){
        this.props.DeleteMeters(TenantID,Data);
        this.Deletetoggle();
     }
     else{
        this.Deletetoggle();
     }

  }
  else{
    this.Deletetoggle();
  }
}

toggleMeter(){
  this.setState({DatalogModalSearch: !this.state.DatalogModalSearch});
}

CloseModal = (someArg1) => {
  
  if(someArg1!='Cancel'){ 
    if(!IsEdit){
      this.props.SaveMeterDetails(TenantID,someArg1);
    }
    else{
        let EditData = [];
        EditData.push({ObjectId:someArg1.objectId,ObjectName:someArg1.objectName,BuildingName:someArg1.buildingName,
          BuildingId:someArg1.buildingId,ParentObjectId:someArg1.parentObjectId,FamilyTypeId:someArg1.familyTypeId,
          Dimension:someArg1.dimension,MeterType:0,Unit:someArg1.unit,UnitText:someArg1.unitText,
          CustomName:someArg1.customName,Rate:parseFloat(someArg1.rate),Multiplier:parseFloat(someArg1.multiplier),
          ConsumptionSettingId:MeterDetail[0].consumptionSettingId              
        });
        this.props.UpdateMeterDetails(TenantID, MeterDetail[0].consumptionId , EditData[0]);        
    }
  }
  IsEdit = false;
  this.toggleMeter();
}

onSort = (column) => (e) => {
  this.setState({IsDefaultSort:false});
  var SortData = this.state.sort.direction;
  var selected = SortData.filter(a => a.name == column);
  const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
  var data_from_state = this.props.UsageMeters_response;
  var notequals = 0;

 if(data_from_state != null){
  const sortedData = this.props.UsageMeters_response.sort((a, b) => {
      const nameA = a[column].toLowerCase();
      const nameB = b[column].toLowerCase();
      if (nameA < nameB) {
          notequals = 1;
          return -1;
      }
      if (nameA > nameB) {
          notequals = 1;
          return 1;
      }
      if (nameA == nameB) {
          return 0;
      }
      return 0;
  });

  if(selected[0].direction =='asc' && notequals == 1){
  sortedData.reverse();
}
SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

   this.setState({
       sort: {
           column,
           direction:SortData,
       }
   });
  }
}

setArrow = (column) => {
  let className = 'workorder-sort-direction';
  let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
  className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
  return className;
};

    render(UsageMeters_response, CurrencyID, getLabels, UserPreference_response, UserCanEdit) {
      let CurrencySym = '$', Error_Message;
      if(this.props.CurrencyID != undefined && this.props.CurrencyID != null && this.props.CurrencyID != ""){
        CurrencySym = Currencies.CurrencySymbol(this.props.CurrencyID);
      }

      let lUserCanEdit = this.props.UserCanEdit;
      lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
        

      let label = this.props.getLabels;
      let PreferedDateFormat = this.props.UserPreference_response;
      // Error Message
      (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  Error: Select one or more tenant Meter to perform this action.</p> : Error_Message = " ";

       let data, UsageMeters = null;
       data =this.props.UsageMeters_response;// this.state.usage_meters;
       MeterList = data;
       let numberOfRows = 0;
       if(data != undefined && data != null){
        if(data.length > 0)  {
          if(this.state.IsDefaultSort){
            data.sort((a,b)=>{
              let nameA = a['customName'].toLowerCase();
              let nameB = b['customName'].toLowerCase();
              if(nameA < nameB){
                  return -1;
              }
              if(nameA > nameB){
                  return 1;
              }
              if(nameA == nameB){
                  return 0;
              }
              return 0;
            });
          }
          if(this.state.IsChangesSaved){
            data.sort((a,b)=>{
              let nameA = a[this.state.sort.column].toLowerCase();
              let nameB = b[this.state.sort.column].toLowerCase();
              if(nameA < nameB){
                  return -1;
              }
              if(nameA > nameB){
                  return 1;
              }
              if(nameA == nameB){
                  return 0;
              }
              return 0;
            });
            if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
                data.reverse();
            }
            this.setState({IsChangesSaved: false});
          }
           numberOfRows   = data.length;
              if(numberOfRows){
                    let rows = [];
                    for (let i = 0; i < numberOfRows; i++) {
                        var l_value = "No Data Found";
                        
                        if(data[i].datalogValue != null){
                          l_value = Conversions.formatNumber(PreferedDateFormat,(data[i].datalogValue).toFixed('2')) + " "+ (data[i].unit != 0 && MeterList[i].unit != 99999 ? DMResources.FamilyList('Enum3046.'+ data[i].unit +'.Text') : data[i].unitText);
                        }

                           rows.push(
                                 <tr><td><input type="checkbox" id={data[i].consumptionId} className="UsageRows" onClick={() => {SelectAllCheckboxes.ResetHeaderCheckBox("UsageRows","AvailUsage_header_Check_box");}}/></td>  
                                 {
                                   lUserCanEdit ? <td onClick={() => {this.ViewMeterDetailslink(data[i].consumptionId)}} style={{color:'#6890C6'}} className="link_cursor">{data[i].customName}</td>  : 
                                   <td className="link_cursor">{data[i].customName}</td> 
                                 }
                                 
                                 <td>
                                 {
                                   (data[i].buildingName !== "" && data[i].objectName !== "") ?
                                   data[i].buildingName + " , " + data[i].objectName : ""
                                 }
                                 </td>
                                 <td>{data[i].multiplier}</td>
                                 <td style={{"font-family":"Arial"}}>{CurrencySym + " " + Conversions.formatNumber(PreferedDateFormat,(data[i].rate).toFixed('2')) }{' per '}{data[i].unit != 0 && MeterList[i].unit != 99999 ? DMResources.FamilyList('Enum3046.'+ data[i].unit +'.Text') : data[i].unitText}</td>
                                 <td>{l_value}</td>  
                                </tr>
                         );
               }  
              UsageMeters =  rows;         
            } 
         }
         else{
          UsageMeters = <tr><td colSpan="6">No Records Found</td></tr>
         }
        }
        else{
          UsageMeters = <tr><td colSpan="6">No Records Found</td></tr>
        }

      return (
        <div>
          <div className="main_container">
          {Error_Message}
          <div className="buttons_container">
              <Button id="edittenant_meter_delete" type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.DeleteMeter}>Delete  </Button>
              <Button id="edittenant_meter_add" type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.toggleMeter} >Add Meters  </Button>
            </div>
            <div className="table_container">
              <Table striped responsive className="Custom_table table_border">
                <tbody className="cell_container tenant_cell">
                  <tr>
                    <th><input type="checkbox" id="main_Check_box" className="AvailUsage_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("UsageRows","AvailUsage_header_Check_box"); }} /></th>
                    <th onClick={this.onSort('customName')}>{label['FixedRateSetup.Name.Text'] !== undefined ? label['FixedRateSetup.Name.Text'] : "Name"} <span className={this.setArrow('customName')}></span></th>
                    <th>{label['TenantConsumption.DataSource.Text'] !== undefined ? label['TenantConsumption.DataSource.Text'] : "Data Source"}</th>
                    <th>{label['TenantConsumption.Multiplier.Text'] !== undefined ? label['TenantConsumption.Multiplier.Text'] : "Multiplier"}</th>
                    <th>{label['TenantConsumption.Rate.Text'] !== undefined ? label['TenantConsumption.Rate.Text'] : "Rate"}</th>
                    <th>{label['TenantConsumption.CurrentReading.Text'] !== undefined ? label['TenantConsumption.CurrentReading.Text'] : "Current Reading"}</th>
                  </tr>
                  {UsageMeters}
                </tbody>
              </Table>
            </div>
          </div>
          <Modal isOpen={this.state.Deletemodal} Deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
            <DeleteConfirmation parentToChildData={["Are you sure you want to delete Meter(s)"]}   Delete = {this.Delete}   />
          </Modal>
          <Modal isOpen={this.state.DatalogModalSearch} style={{'width':'990px','height':'400px'}} className="AddMetersSearch">
            <AddMetersSearch CloseModal = {this.CloseModal} TenantID={TenantID} IsTabbedView={true} MeterListDetail = {MeterDetail[0]}  IsEdit={IsEdit} />
          </Modal>
        </div>
      );
    }
    }

    const mapStateToProps = state => {
      return {
        UsageMeters_response: state.ViewtenantsRootReducer.UsageMeters,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        CurrencyID: state.ViewtenantsRootReducer.CompanyInformation.currencyId,
        UserCanEdit: state.authService.HasApplicationFullAcess
      };
    };

    const mapDispatchToProps = dispatch => {
      return {
          SaveMeterDetails: (TenantID, data) => dispatch(SaveMeterDetails(TenantID, data)),
          UpdateMeterDetails: (TenantID,ConsumptionId,data) => dispatch(UpdateMeterDetails(TenantID,ConsumptionId,data)),
          DeleteMeters: (TenantId,data) => dispatch(DeleteMeters(TenantId,data)),
          GetMeterListforTenant: (TenantID) =>  dispatch(GetMeterListforTenant(TenantID))
      };
    };
    
    
    export default connect(mapStateToProps, mapDispatchToProps)(ViewUsageMeters);




